module.exports = __webpack_public_path__ + "img/q2.ebcd6771.jpg";